import React, { useEffect, useRef, useState } from 'react';
import LazyImage from '../../Utils/Components/imageComponent';
import placeholder from '../../../assets/images/img.jpg';
import { globalEnv } from '../../../config/baseConfig';
import axios from 'axios';
import { useTypedSelector } from '../../../hooks/useTypeSelector';
import Scrollbars from 'react-custom-scrollbars-2';
import { axiosInstance } from '../../../config/axiosInstance';
import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';
import { SetNotificationAction } from '../../../redux/actions/notificationAction';
import { stateNotificationsEnum } from '../../Utils/notification';
import SaveButton from '../../Utils/saveButton';
import { useNavigate } from 'react-router-dom';

export default function CreateExtensionModal() {
	const [isChanged, setIsChanged] = useState(false);
	const [extensionName, setExtensionName] = useState('');
	const [extensionUrl, setExtensionUrl] = useState('');

	const [updatedTopic, setUpdatedTopic] = useState<any>();
	const [coverPicLowRes, setCoverPicLowRes] = useState<string>('');

	const [selectedTopicName, setSelectedTopicName] = useState('');

	const [topicsList, setTopicsList] = useState([]);
	const [page, setPage] = useState(1);
	const [isShown, setIsShown] = useState(false);
	const [noTopicsFound, setNoTopicsFound] = useState(false);
	const [isSaving, setIsSaving] = useState(false);

	const [searchResultsRef, setSearchResultsRef] = useState(useRef());

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);

	useEffect(() => {
		const delayDebounceFn = setTimeout(() => {
			setNoTopicsFound(false);
			fetchEditorsList(selectedTopicName);
		}, 600);

		return () => clearTimeout(delayDebounceFn);
	}, [selectedTopicName]);

	useEffect(() => {
		if (updatedTopic != null) {
			setCoverPicLowRes(updatedTopic.backgroundImage.url_low_res);
			setSelectedTopicName(updatedTopic.name);
		}
	}, [updatedTopic]);

	async function fetchEditorsList(searchTerm: string) {
		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		try {
			const { data } = await axios.get(
				`${globalEnv.BASE_URL}/topic/get-all?filter=${searchTerm}&page=${page}`,
				config
			);
			if (data.meta.pages < page) {
				setPage(1);
			}
			setTopicsList(data.topics);
		} catch (e) {
			setTopicsList([]);
			setNoTopicsFound(true);
		}
	}

	const saveExtensionReq = async () => {
		const dto = {
			name: extensionName,
			url: extensionUrl,
			topic: updatedTopic._id
		};

		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		const { data: response } = await axiosInstance.post(
			globalEnv.BASE_URL + '/extension/create',
			dto,
			config
		);
		return response;
	};

	const dispatch = useDispatch();
	const navigate = useNavigate();
	const saveTopic = useMutation(saveExtensionReq, {
		onMutate: () => setIsSaving(true),
		onSuccess: (data) => {
			setIsSaving(false);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.SUCCESS,
					message: 'Successfully created extension.'
				})
			);
			navigate(`../extensions/${data._id}/select-menu`);
		},
		onError: () => {
			setIsSaving(false);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: "Couldn't update topic info."
				})
			);
		}
	});

	const topicSearchRef = useRef(null) as any;
	return (
		<div
			className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2
                            w-4/6 md:h-auto ml-8 px-4 py-2 max-h-[80%] mt-10 flex flex-col "
		>
			<div
				className="relative bg-gray-100 w-full max-h-screen overflow-y-auto h-[400px]
                                        dark:bg-gray-900 transition-colors duration-300 rounded-t-xl pt-5 pl-5"
				// onClick={() => setIsShown(!isShown)}
			>
				<div className="flex flex-col justify-center px-4 py-2">
					<h3 className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xl font-bold mb-2 px-3 self-center">
						Create new extension
					</h3>
				</div>
				<div className="flex flex-row w-full">
					<div className="w-32 h-32 flex justify-center flex-shrink-0 align-middle self-center mr-3">
						{updatedTopic != null && (
							<LazyImage
								photo={
									coverPicLowRes != null
										? coverPicLowRes != null
											? coverPicLowRes
											: placeholder
										: placeholder
								}
								style={
									'block object-cover object-center w-full aspect-[1/1] rounded-lg'
								}
							/>
						)}
					</div>
					<div className=" w-2/3">
						<div className="mt-2 mb-2">
							<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xs font-bold mb-1">
								Extension name
							</label>
							<input
								className="inputStyle2"
								id="grid-last-name"
								type="text"
								placeholder="Extension Name"
								onChange={(e) => {
									setExtensionName(e.target.value);
									setIsChanged(true);
								}}
								value={extensionName}
							/>
						</div>
						<div className="mt-2 mb-2">
							<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xs font-bold mb-1">
								Extension URL
							</label>
							<input
								className="inputStyle2"
								id="grid-last-name"
								type="text"
								placeholder="Extension URL"
								onChange={(e) => {
									setExtensionUrl(e.target.value);
									setIsChanged(true);
								}}
								value={extensionUrl}
							/>
						</div>
						<div className="mb-2">
							<div>
								<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xs font-bold mb-1">
									Selected Topic
								</label>
								<input
									className="inputStyle2"
									id="grid-last-name"
									type="text"
									placeholder="Topic Name"
									onChange={(e) => {
										setSelectedTopicName(e.target.value);
									}}
									onFocus={() => {
										setIsShown(true);
									}}
									ref={topicSearchRef}
									value={selectedTopicName}
								/>
							</div>
						</div>

						{isShown &&
							(noTopicsFound ? (
								<div className="absolute z-50  bg-gray-100 dark:bg-gray-700 mt-2 w-3/12 h-fit flex flex-col items-start rounded-lg overflow-hidden  ">
									<a className="w-full h-14 flex items-start" target="_blank">
										<p className="ml-2 hover:bg-gray-400 align-middle self-center dark:text-gray-200">
											No topics found
										</p>
									</a>
								</div>
							) : (
								<TopicElem
									topicsList={topicsList}
									setMyRef={setSearchResultsRef}
									setTopic={setUpdatedTopic}
									setIsChanged={setIsChanged}
									setIsShown={setIsShown}
								/>
							))}
					</div>
				</div>
			</div>
			<div
				className="flex flex-row justify-end pt-3 pb-2 px-6 space-x-2 -mt-1
						bg-gray-100 dark:bg-gray-900 shadow-lg transition-colors duration-300 rounded-b-xl"
			>
				<SaveButton
					isSaving={isSaving}
					saveFunc={() => {
						saveTopic.mutate();
					}}
					text="Create extension"
				/>
			</div>
		</div>
	);
}

function TopicElem({
	topicsList,
	setMyRef,
	setTopic,
	setIsChanged,
	setIsShown
}: {
	topicsList: any[];
	setMyRef: (ref: any) => void;
	setTopic: (contibutors: any[]) => void;
	setIsChanged: (ismodalOpen: boolean) => void;
	setIsShown: (isShown: boolean) => void;
}) {
	const nodeRef: any = useRef(null); // optional
	useEffect(() => {
		setMyRef(nodeRef);
	}, [nodeRef]);

	const setTopicAsSelected = (topic: any) => {
		setTopic(topic);
		setIsChanged(true);
	};

	return (
		<div className="rounded-xl h-full w-6/12 overflow-hidden">
			<Scrollbars autoHide>
				<div
					ref={nodeRef}
					className="absolute z-50 h-fit w-full bg-gray-100 dark:bg-gray-700 flex flex-col items-start rounded-lg overflow-hidden "
				>
					{topicsList.slice(0, 15).map((topic: any, key) => {
						return (
							<div
								className="w-full h-full flex items-start align-middle px-4 py-3 dark:hover:bg-gray-600 hover:bg-gray-400 cursor-pointer"
								onClick={() => {
									setTopicAsSelected(topic);
									setIsShown(false);
								}}
							>
								<div className="mr-2">
									<LazyImage
										photo={
											topic.backgroundImage != null
												? topic.backgroundImage.url_low_res
												: `https://api.dicebear.com/7.x/bottts/svg?seed=${topic.name}`
										}
										dimesnions={'25'}
										loaderDimesnions={23}
									/>
								</div>
								<div className="font-medium text-sm mt-0.5 text-gray-800 dark:text-white group-hover:text-white dark:group-hover:text-gray-800">
									{topic.name}
								</div>
							</div>
						);
					})}
				</div>
			</Scrollbars>
		</div>
	);
}
